import { AuthProvider } from '@heidi/auth/contracts';
import { useIsAuthenticated } from '@heidi/auth/state';
import type { components } from '@heidi/schema/ml-scribe';
import { useQuery } from '@tanstack/react-query';

import { GET_USER_EHR_LAUNCH_PROFILES } from '../../contracts/queryKeys';
import {
  getUserEHRLaunchProfile,
  getUserEHRLaunchProfileAuth0,
} from '../api/launch-profile';

type UserEHRLaunchProfile = components['schemas']['UserEHRLaunchProfile'];

export function useQueryUserEHRLaunchProfiles<T = UserEHRLaunchProfile[]>({
  authProvider,
  enabled,
  select,
}: {
  authProvider: AuthProvider | undefined;
  enabled: boolean;
  select?: (data: UserEHRLaunchProfile[]) => T;
}) {
  const { isAuthenticated } = useIsAuthenticated();
  const isAuth0Login =
    authProvider === AuthProvider.AUTH0 || authProvider === AuthProvider.AUTH0_DESKTOP;

  return useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps -- isAuth0Login is derived from authProvider
    queryKey: [GET_USER_EHR_LAUNCH_PROFILES, { authProvider }],
    enabled: enabled && isAuthenticated,
    select,
    queryFn: async () => {
      const { data } = isAuth0Login
        ? await getUserEHRLaunchProfileAuth0()
        : await getUserEHRLaunchProfile();
      return data?.user_ehr_launch_profiles ?? [];
    },
  });
}
